import ApiService from '@/services/ApiService';

export default {
  getCurrentLocation(data) {
    // return ApiService().get('https://api.ipregistry.co/?key=1tf0qbu5g8s61x&fields=location', data, true);
    // check current location with api free
    return ApiService().get('/countries/all', null, true);
  },
  getLangLocation() {
    // return ApiService().get('/detect-country-code', data, true);
    return ApiService().get('/languages/all', null, true);
  },
  getStateLocation(key) {
    // return ApiService().get('/detect-country-code', data, true);
    return ApiService().get(`/countries/states/${key}`);
  },
  getCityLocation(key) {
    // return ApiService().get('/detect-country-code', data, true);
    return ApiService().get(`/states/cities/${key}`);
  }
};
